const baseURL = process.env.REACT_APP_BASE_URL;

const getToken = () => {
   const token = localStorage.getItem('token');
   return `Bearer ${token}`
}

export {
   baseURL,
   getToken
}
